import { dataChevronRightCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronRightCircle = /*#__PURE__*/createIcon(dataChevronRightCircle)
export default IconChevronRightCircle
